<script>
    export default {
        abstract: true,
        render() {
            return this.$slots.default[0];
        }
    };
</script>
